/* RESPONSIBLE TEAM: team-ml */
import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';
import type { Block } from '@intercom/interblocks.ts';

// embercom is presently taking data from the BE and sending it down to the react app
// since we are building a full page react editor experience, this is temporary
// instead of duplicating all the types relevant to the react editor, we're going to
// trust and pass along what we get from the BE in embercom for now.
type BlockWithContent = Block & { content: any };
type BlockListWithContent = BlockWithContent[];

interface TaskSection {
  type: 'taskSection';
  name: string;
  text: string;
}

export default class FinCustomProcedureContent extends Fragment {
  @attr('array', {
    defaultValue: () => [
      {
        type: 'taskStep',
        content: {
          type: 'instructionTaskStep',
          content: [
            {
              type: 'paragraph',
              text: '',
            },
          ],
        },
      },
      {
        type: 'taskStep',
        content: {
          type: 'instructionTaskStep',
          content: [
            {
              type: 'paragraph',
              text: '',
            },
          ],
        },
      },
    ],
  })
  declare content: BlockListWithContent;
  @attr('array') declare sections: TaskSection[];
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'operator/visual-builder/step/fin-custom/procedure-content': FinCustomProcedureContent;
  }
}
